import { ThemeProvider, createTheme, CssBaseline, GlobalStyles } from '@mui/material';

const globalStyles = {
  body:{
    color: '#000',
  },
  '#contact-us-root': {
    color: '#393533',
    boxSizing: 'border-box',
  },
}

const theme = createTheme({
breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1050,
      xl: 1200,
      xxl: 1536
    }
  },
  typography: {
    fontFamily: 'Circular',
    cmp: {
      sizes: {
        xs: '0.625rem',   // 10px
        sm: '0.75rem',    // 12px
        md: '0.875rem',   // 14px
        base: '1rem',     // 16px
        lg: '1.125rem',   // 18px
        titleMd: '1.2rem',
        titleLg: '1.5rem',
        titleXl: '2rem',
      },
      weights: {
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
      },
      lineHeights: {
        tight: 1.2,
        base: 1.5,
        relaxed: 1.75,
      },
      labelMdBold: { fontSize: '0.875rem', fontWeight: 700 },
      labelLgBold: { fontSize: '1rem', fontWeight: 700 },
      labelMdMedium: { fontSize: '0.875rem', fontWeight: 500 },
      bodyBase: { fontSize: '1rem', fontWeight: 400 },
      bodyLg: { fontSize: '1.125rem', fontWeight: 400 },
      titleMdBold: { fontSize: '1.2rem', fontWeight: 700 },
      titleLgBold: { fontSize: '1.5rem', fontWeight: 700 },
      chipSm: { fontSize: '0.75rem', fontWeight: 500 },
    },
  },
});

export const MuiThemeProvider = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <GlobalStyles styles={globalStyles} />
    {children}
  </ThemeProvider>
);